module.exports = __webpack_public_path__ + "static/img/no_default.71e32fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/default_images/no_default.png
// module id = o0BL
// module chunks = 95